import * as React from 'react'

export const PriceExplanationMark = () => {
  return <span className="text-xs align-top ml-0.5 text-danger-main">*</span>
}
